import { Clip } from '@/types/clip.types';
import { ListMusic } from 'lucide-react';

function formatDuration(seconds: number | null): string {
  if (seconds === null || seconds === undefined) return '--:--';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

interface PublishedClipsListProps {
  clips: Clip[];
}

export function PublishedClipsList({ clips }: PublishedClipsListProps) {
  if (clips.length === 0) {
    return null;
  }

  // Sort clips by position
  const sortedClips = [...clips].sort((a, b) => a.position - b.position);

  return (
    <div className="mt-6 pt-4 p-4 rounded-md">
      <div className="flex items-center gap-2 mb-3">
        <ListMusic className="h-4 w-4 text-muted-foreground" />
        <h4 className="font-medium">Episode Clips</h4>
        <span className="text-sm text-muted-foreground">({clips.length})</span>
      </div>
      <div className="space-y-2">
        {sortedClips.map((clip, index) => (
          <div
            key={clip.id}
            className="flex items-center justify-between py-2 px-3 rounded-md bg-muted/50"
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-sm text-muted-foreground font-mono w-6 text-center">
                {index + 1}
              </span>
              <span className="text-sm font-medium truncate">{clip.articleTitle}</span>
            </div>
            <span className="text-sm text-muted-foreground flex-shrink-0 ml-4">
              {clip.duration ? formatDuration(clip.duration) : '--:--'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
